import storage from './StorageService';

export const guestIdentity = {
    account: {
        name: 'Guest',
    }
};

export const getIdentity = async (): Promise<DarknetIdentity> => {
    const storageIdentity = await storage.get('identity');
    if (storageIdentity) return JSON.parse(storageIdentity)
    else return guestIdentity;
}

export function setStorageIdentity(identity: DarknetIdentity) {
    storage.set('identity', JSON.stringify(identity));
}

export function resetStorageIdentity() {
    storage.remove('identity');
}